<template>
  <v-overlay
      v-model="appIsLoading"
      eager
      disabled
      persistent
      scrim="#000000"
      opacity="0.3"
      class="d-flex align-center justify-center"
  >
    <v-progress-circular
        :size="200"
        :width="20"
        color="white"
        indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>

<script setup>
import {ref} from "vue";

const appIsLoading = ref(true);
</script>